<template>
  <div class="detailPage" v-if="isShow">
    <div class="content line">
      <div class="order_info">
        <p>订单号：{{ dataItem.orderno }}</p>
        <p>创建时间：{{ dataItem.createdate | formatDate }}</p>
        <p>销售专员姓名：{{ dataItem.saler }}</p>
      </div>
      <div class="block" v-for="(item, index) in dataItem.goods" :key="index">
        <h1>商品名称：{{ item.commodityname }}</h1>
        <h1>
          商品ID：<span>{{ item.id }}</span>
        </h1>
        <h1>
          商品SKU：<span>{{ item.sku }}</span>
        </h1>
        <h1 v-if="item.cbprice">
          成本参考价：<span>¥ {{ item.cbprice | formatPrice }}/件</span>
        </h1>
        <h1 v-if="item.price">
          基础零售价：<span>¥ {{ item.price | formatPrice }}/件</span>
        </h1>
        <h1 v-if="item.pfprice">
          批发参考价：<span>¥ {{ item.pfprice | formatPrice }}/件</span>
        </h1>
        <h1 v-if="item.groupprice">
          基础批发价：<span>¥ {{ item.groupprice }}/件</span>
        </h1>
        <h1>
          <p v-for="(label, labelIndex) in item.attr" :key="labelIndex">
            <span>{{ label }}</span
            ><span>：{{ item.attrPrice }}/件</span>
          </p>
        </h1>
        <h1>
          商品数量：<span>{{ item.num }}</span>
        </h1>
        <h1>
          价格小计：<span>{{ item.newPrice | formatPrice }}</span>
        </h1>
        <h1>商品类型：<span>主商品</span></h1>
      </div>
      <div
        class="block"
        v-for="(item, index) in dataItem.goods_pei"
        :key="index"
      >
        <h1>商品名称：{{ item.commodityname }}</h1>
        <h1>
          商品ID：<span>{{ item.id }}</span>
        </h1>
        <h1>
          商品SKU：<span>{{ item.sku }}</span>
        </h1>
        <h1 v-if="item.cbprice">
          成本参考价：<span>¥ {{ item.cbprice }}/件</span>
        </h1>
        <h1 v-if="item.price">
          基础零售价：<span>¥ {{ item.price }}/件</span>
        </h1>
        <h1 v-if="item.pfprice">
          批发参考价：<span>¥ {{ item.pfprice }}/件</span>
        </h1>
        <h1 v-if="item.groupprice">
          基础批发价：<span>¥ {{ item.groupprice }}/件</span>
        </h1>
        <h1>
          商品数量：<span>{{ item.num }}</span>
        </h1>
        <h1>
          价格小计：<span>{{ item.newPrice }}</span>
        </h1>
        <h1>商品类型：<span>配件</span></h1>
      </div>
    </div>
    <div class="content line">
      <div class="address_wrap">
        <div class="item flex-rowl">
          <p>购买人：</p>
          <p>{{ dataItem.qy_truename }}</p>
        </div>
        <div class="item flex-rowl">
          <p>购买人联系方式：</p>
          <p>{{ dataItem.qy_linktype }}</p>
        </div>
        <div class="item flex-rowl">
          <p>客户企业：</p>
          <p>{{ dataItem.qw_appidstr }}</p>
        </div>
        <div class="item flex-rowl">
          <p>客户职务：</p>
          <p>{{ dataItem.qw_job }}</p>
        </div>
        <div class="item flex-rowl">
          <p>收件人：</p>
          <p>{{ dataItem.truename }}</p>
        </div>
        <div class="item flex-rowl">
          <p>收件人联系方式：</p>
          <p>{{ dataItem.cellphone }}</p>
        </div>
        <div class="item flex-rowl">
          <p>测试省/直辖市</p>
          <p>{{ dataItem.addr }}</p>
        </div>
        <!-- <div class="txt">
          详细地址信息，预设输入时最多输入50个中文字，在这里显示时
          可以换行，最多三行
        </div> -->
      </div>
    </div>
    <div class="content line">
      <div class="price flex-between">
        <p>订单价格核算：</p>
        <p v-if="dataItem.price_original">
          <span>￥</span>{{ dataItem.price_original | formatPrice }}
        </p>
      </div>
    </div>
    <div class="content line">
      <div class="price flex-between">
        <p>实际订单价格：</p>
        <p><span>￥</span>{{ dataItem.price | formatPrice }}</p>
      </div>
      <!-- <div class="price_btm flex-between">
        <p>差额：</p>
        <p><span>￥</span>{{ dataItem.runfee }}</p>
      </div> -->
      <div class="price_other">
        <div class="txt flex-between">
          <p>订单审核状态：</p>
          <p class="red">
            {{
              dataItem.ischeck == 0
                ? "待审核"
                : dataItem.ischeck == 1
                ? "审核通过"
                : dataItem.ischeck == 2
                ? "审核不通过"
                : ""
            }}
          </p>
        </div>
        <div class="txt1 flex-between">
          <p>已付金额：</p>
          <p v-if="dataItem.paynum">￥{{ dataItem.paynum | formatPrice }}</p>
          <p v-else>￥ 0.00</p>
        </div>
        <div class="txt1 flex-between">
          <p>差额：</p>
          <p v-if="dataItem.diffrentprice">
            ￥{{ dataItem.diffrentprice | formatPrice }}
          </p>
          <p v-else>￥ 0.00</p>
        </div>
        <div class="txt1 flex-between">
          <p>待结清金额：</p>
          <p v-if="dataItem.waitMoney">
            ￥{{ dataItem.waitMoney | formatPrice }}
          </p>
          <p v-else>￥ 0.00</p>
        </div>
        <div class="detail_btn">
          查看付款记录明细 <i class="iconfont icon-gengduo"></i>
        </div>
      </div>
    </div>
    <div class="pay_wrap line">
      <div class="tit">支付方式：{{ dataItem.paymsg }}</div>
      <div class="block">
        <p>银行账户名：{{ dataItem.paymsg_truename }}</p>
        <p>开户行：{{ dataItem.paymsg_bank }}</p>
        <p>银行账号：{{ dataItem.paymsg_account }}</p>
      </div>
      <div class="mark">
        <h1>备注信息：</h1>
        <p>{{ dataItem.saler_note ? dataItem.saler_note : "无备注信息" }}</p>
      </div>
    </div>
    <div class="status_wrap">
      <div class="block">
        <div class="txt1 flex-between">
          <p>退费申请状态：</p>
          <p class="red">
            {{
              dataItem.isreturn === true
                ? "是"
                : dataItem.isreturn === false
                ? "否"
                : "无"
            }}
          </p>
        </div>
        <div class="txt flex-between">
          <p>退费状态：</p>
          <p class="red">
            {{ dataItem.returnstate ? dataItem.returnstate : "无" }}
          </p>
        </div>
      </div>
      <div class="block1">
        <div class="txt1 flex-between">
          <p>订单情况：</p>
          <p class="red">
            {{
              dataItem.ordertalk == 1
                ? "进行中"
                : dataItem.ordertalk == 2
                ? "已完成"
                : dataItem.ordertalk == 3
                ? "已关闭"
                : "无"
            }}
          </p>
        </div>
        <div class="txt flex-between" v-if="type =='cRetailOrderList' || type == 'cClientOrderList'">
          <p>发货情况：</p>
          <p class="red">{{ dataItem.orderstate }}</p>
        </div>

        <div class="txt flex-between" v-if="type =='cSellOrderList' || type == 'cBusinessOrderList'">
          <p>发货统计：</p>
          <p class="red"></p>
        </div>
      </div>
    </div>

    <!-- 底部操作 -->
    <div class="goods-bottom-operation flex-rowl" v-if="isShow">
      <div class="arr" @click="handleReturn">
        <i class="iconfont icon-bottom"></i>
      </div>
      <!-- 业务订单审核 -->
      <template v-if="type == 'cBusinessOrderList'">
        <div class="item flex-rowc" :class="{ disabled: dataItem.ischeck != 1 }" @click="handleGo('cPaymentList', 'sk')">
          订单收款管理
        </div>
        <div class="item flex-rowc" @click="handleGo('cOrderCheck')">
          订单审核管理
        </div>
        <div class="item flex-rowc" @click="handleToast">订单关闭</div>
      </template>
      <!-- 销售业务管理 -->
      <template v-else-if="type == 'cSellOrderList'">
        <div
          class="item flex-rowc"
          :class="{ disabled: dataItem.ischeck != 1 }"
          @click="handleGo('cPaymentList', 'shdj')"
        >
          收款登记
        </div>
        <div class="item flex-rowc" @click="handleToast">发货管理</div>
      </template>
      <template v-else>
        <div class="item flex-rowc" @click="handleToast">收款登记</div>
        <div class="item flex-rowc">发货计划</div>
        <div class="item flex-rowc" @click="handleToast">退款申请</div>
      </template>
      <!-- <div class="item flex-rowc" @click="handleToast" v-if="type == 'cBusinessOrderList'">订单收款管理</div>
      <div class="item flex-rowc" @click="handleToast" v-else>收款登记</div>
      <div class="item flex-rowc">发货计划</div>
      <div class="item flex-rowc" @click="handleToast">退款申请</div>
      <div class="item flex-rowc" @click="handleToast">订单关闭</div> -->
    </div>
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../../api/api";
import { getOrderListDetail } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "cOrderDetail",
  data() {
    return {
      isShow: false,
      qyid: "",
      dataItem: "",
      type: "",
      orderId: '',
      orderOpenid: ''
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) "0.00";
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyid = USERINFO.qy ? USERINFO.qy.id : "";
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, openid, type } = JSON.parse(res.jsondata);
        this.type = type;
        this.orderId = id
        this.orderOpenid = openid
        this.getOrderListDetail(id, openid);
      } else {
        this.$router.back();
      }
    },

    // 订单列表
    getOrderListDetail(id, openid) {
      let params = {
        openid: openid,
        orderid: id,
      };
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getOrderListDetail(params).then((res) => {
        let newObj = res[0];
        let newGoods =
          newObj.goodsjson != "" && newObj.goodsjson
            ? JSON.parse(newObj.goodsjson)
            : "";
        if (newObj.goods.length > 0) {
          newObj.goods.forEach((v1, index) => {
            v1.attr = v1.attr != "" ? JSON.parse(v1.attr) : v1.attr;
            if (newGoods != "") {
              v1.orderGood = newGoods[index];
              // 单件商品总价 (零售价 +/- 标签价) * 数量  后续加入折扣价针对于第一个商品
              let attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "-" + v1.orderGood.attrnum
                  : v1.orderGood.attrnum;

              v1.attrPrice =
                v1.orderGood.attrnumtype == "不变"
                  ? "¥" + 0
                  : v1.orderGood.attrnumtype == "减少"
                  ? "- ¥" + v1.orderGood.attrnum
                  : "+ ¥" + v1.orderGood.attrnum;
              v1.newPrice = calculator(calculator(v1.price).add(attrPrice))
                .multiply(v1.num)
                .toNumber();
            } else {
              v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
            }
          });
        }
        if (newObj.goods_pei.length > 0) {
          newObj.goods_pei.forEach((v1) => {
            v1.newPrice = calculator(v1.price).multiply(v1.num).toNumber();
          });
        }
        // 待结清金额 = price - paynum
        newObj.waitMoney = calculator(newObj.price)
          .subtract(newObj.paynum ? newObj.paynum : 0)
          .toNumber();
        this.dataItem = newObj;
        this.isShow = true;
        Toast.clear();
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleToast() {
      this.$toast("即将开放");
    },

    // 计算商品差价
    shopPriceDifference(price, price1) {
      return calculator(price1).subtract(price).toNumber();
    },

    handleGo(type, state) {
      let {dataItem, orderId, orderOpenid} = this
      if(type == 'cPaymentList' && dataItem.ischeck != 1) {
        // this.$message.warning("即将开放");
      }else {
        this.encryptstringadd(type, { orderno: dataItem.orderno, orderId, orderOpenid, state });
      }
      
      // this.$router.push(`/comSalesIndex/cOrderDetail/${id}/${openid}/${this.type}`);
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: '',
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.detailPage {
  padding-bottom: 300px;
  .line {
    border-bottom: 9px solid #f5f5f5;
  }
  .content {
    padding: 39px 42px 47px;
    .order_info {
      font-size: 22px;
      color: #3c3c3c;
      margin-bottom: 25px;
      p {
        &:nth-child(2) {
          margin: 15px 0;
        }
      }
    }
    .block {
      margin-bottom: 50px;
      &:last-child {
        margin-bottom: 0;
      }
      h1 {
        font-size: 20px;
        color: #3c3c3c;
        margin-bottom: 9px;
      }
      .txt {
        margin-bottom: 19px;
        p {
          font-size: 18px;
          color: #969696;
          line-height: 30px;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .price {
      font-size: 24px;
      p {
        &:last-child {
          font-size: 40px;
          span {
            font-size: 24px;
            margin-right: 10px;
          }
        }
      }
    }
    .price_btm {
      margin-top: 50px;
      font-size: 24px;
      p {
        &:last-child {
          font-size: 20px;
          span {
            font-size: 22px;
          }
        }
      }
    }
    .price_other {
      font-size: 24px;
      span {
        font-size: 24px;
        margin-right: 22px;
      }
      .txt {
        margin: 77px 0 50px;
        .red {
          font-size: 40px;
          color: #ee0032;
        }
      }
      .txt1 {
        p {
          &:last-child {
            font-size: 40px;
          }
        }
      }
      .detail_btn {
        height: 40px;
        line-height: 40px;
        margin: 0;
        padding: 0 20px;
        font-size: 18px;
        border: 1px solid #aaaaaa;
        display: inline-block;
        border-radius: 22px;
        margin-top: 29px;
      }
    }
  }
  .address_wrap {
    font-size: 22px;
    .item {
      margin-bottom: 30px;
      align-items: flex-start;
      p {
        &:first-child {
          white-space: nowrap;
          width: 190px;
        }
      }
    }
    .txt {
      font-size: 20px;
      line-height: 30px;
    }
  }
  .pay_wrap {
    padding: 42px 57px 150px;
    font-size: 24px;
    box-sizing: border-box;
    .tit {
      margin-bottom: 70px;
    }
    .block {
      font-size: 22px;
      color: #aaaaaa;
      margin-bottom: 59px;
      padding-left: 39px;
      p {
        margin-bottom: 35px;
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
    .mark {
      font-size: 22px;
      padding-left: 39px;
      p {
        color: #aaaaaa;
        margin-top: 28px;
      }
    }
  }
  .status_wrap {
    padding: 55px 58px 0;
    font-size: 22px;
    color: #3c3c3c;
    .red {
      font-size: 30px;
      color: #ee0032;
    }
    .block {
      margin-bottom: 110px;
    }
    .txt1 {
      margin-bottom: 25px;
    }
  }
  .goods-bottom-operation {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 50px 73px 115px 46px;
    .arr {
      transform: rotate(90deg);
      margin-right: 20px;
      .iconfont {
        font-size: 40px;
      }
    }
    .item {
      margin-right: 40px;
      &.disabled {
        color: #a6a6a6;
      }
    }
  }
}
</style>